import {
  SUPPORTED_LOCALE_OPTIONS,
  type SupportedLocale,
} from '../supportedLocales'

export const DEFAULT_LOCALE: SupportedLocale = 'en-AU'
export const SUPPORTED_LOCALES: Array<SupportedLocale> = SUPPORTED_LOCALE_OPTIONS.map(({ locale }) => locale)
